import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=69c94ff6&scoped=true&"
import script from "./Wallet.vue?vue&type=script&lang=js&"
export * from "./Wallet.vue?vue&type=script&lang=js&"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=69c94ff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c94ff6",
  null
  
)

export default component.exports